import React from 'react'
//import parsePhoneNumber from 'libphonenumber-js'

class SingleLineAddress extends React.Component {
  render() {
    const {
      address = {},
      className = '',
      isToHideUserInfo = false,
    } = this.props || {}
    const {
      firstName = '',
      lastName = '',
      addressLine1 = '',
      addressLine2 = '',
      city = '',
      county = '',
      state = '',
      country = '',
      zip = '',
      email = '',
      phone = '',
    } = address

    // to convert phone number to international format
    let phoneNumberCode = ''
    if (phone && phone != null) {
      const phoneNumberCode = async function (phone) {
        const { parsePhoneNumber } = await import('libphonenumber-js')
        parsePhoneNumber(phone)?.formatInternational() || ''
      }
    }

    // end to convert phone number to international format

    const customClassName = isToHideUserInfo ? 'd-none' : ''

    return (
      <span
        data-testid="qa-address"
        className={`item-level-address ${className}`}>
        <div className={`fname-bold-shiping ${customClassName}`}>{`${
          firstName === null ? '' : firstName
        } ${lastName === null ? '' : lastName}`}</div>
        <span className="fname-normal-shiping">
          {`${addressLine1},${
            addressLine2 ? ` ${addressLine2},` : ''
          } ${city}, ${county ? county + ',' : ''} ${
            state ? state + ',' : ''
          } ${zip && country ? zip + ', ' + country : zip || country}`}
        </span>
        <div
          className={`fname-normal-shiping to-lower  ${customClassName}`}>{`${
          email || ''
        }`}</div>
        {phoneNumberCode && (
          <div className={`fname-normal-shiping  ${customClassName}`}>
            {phoneNumberCode}
          </div>
        )}
      </span>
    )
  }
}

export { SingleLineAddress }
